module.exports = __webpack_public_path__ + "img/flux_encours.8c02db9e.jpg";